<div class="field w-full">
  @if (label) {
  <label class="block mb-1 {{ labelCustomClass }}">{{ label }}<span class="text-red-500">*</span>
    @if (secondaryLabel) {
    <i class="text-xs text-gray-500">{{ secondaryLabel }}</i>
    }</label>
  }

  <!-- Wrapper with REAL glow shadow -->
  <div
    class="w-full h-[45px] rounded-md border border-gray-300 focus-within:border-blue-500 transition-all duration-150 shadow-none focus-within:shadow-[0_0_8px_2px_rgba(59,130,246,0.6)] overflow-hidden relative flex items-center bg-white group">

    <!-- Prefix: Flag + Phone Code -->
    <div *ngIf="phoneCode || countryCode"
      class="flex items-center gap-2 px-3 border-r border-gray-200 h-full bg-slate-50 shrink-0 transition-colors duration-150 group-focus-within:bg-slate-100 group-focus-within:border-blue-500">
      <img src="https://primefaces.org/cdn/primeng/images/demo/flag/flag_placeholder.png"
        [class]="'flag flag-' + countryCode?.toLowerCase()" style="width: 18px" />
      <span *ngIf="phoneCode" class="text-sm font-semibold text-slate-600 tracking-tight">{{ phoneCode }}</span>
      <div class="w-[1px] h-4 bg-slate-300 ml-1"></div>
    </div>

    <input #inputRef pInputText [type]="type" [placeholder]="placeholder" [disabled]="disabled" [readonly]="isReadonly"
      [value]="value" (input)="onInput($event)" (blur)="onTouched()"
      class="flex-1 h-full px-4 border-0 outline-none focus:outline-none focus:ring-0 bg-transparent text-sm placeholder:text-slate-400 font-medium text-slate-700"
      [invalid]="(ngControl.invalid || ngControl.errors) && submitted" />

    <button *ngIf="showEdit && isReadonly" type="button"
      class="absolute right-3 top-1/2 -translate-y-1/2 text-blue-600 underline text-sm font-medium"
      (click)="makeEditable()">
      {{ i18n.t('edit') }}
    </button>
  </div>

  <small [appFormErrorMessageDirective]="ngControl.control" [submitted]="submitted"></small>
</div>